/**
 * Announcement Countdown Timer
 * Handles countdown logic for announcement bar
 */

class AnnouncementCountdown {
  constructor(element) {
    this.element = element;
    this.endDate = element.dataset.endDate;
    this.endTime = element.dataset.endTime;
    this.daysElement = element.querySelector('[data-days]');
    this.hoursElement = element.querySelector('[data-hours]');
    this.minutesElement = element.querySelector('[data-minutes]');
    this.secondsElement = element.querySelector('[data-seconds]');
    
    this.endTimestamp = this.parseDateTime(this.endDate, this.endTime);
    this.intervalId = null;
    
    if (this.endTimestamp) {
      this.init();
    }
  }

  parseDateTime(dateStr, timeStr) {
    try {
      // Parse date in DD/MM/YYYY format
      const [day, month, year] = dateStr.split('/').map(Number);
      
      // Parse time in HH:MM:SS format
      const [hours, minutes, seconds] = timeStr.split(':').map(Number);
      
      // Create date object (month is 0-indexed in JavaScript)
      const endDate = new Date(year, month - 1, day, hours, minutes, seconds);
      
      // Validate date
      if (isNaN(endDate.getTime())) {
        console.error('Invalid date or time format');
        return null;
      }
      
      return endDate.getTime();
    } catch (error) {
      console.error('Error parsing date/time:', error);
      return null;
    }
  }

  init() {
    // Calculate immediately
    this.update();
    
    // Update every second
    this.intervalId = setInterval(() => {
      this.update();
    }, 1000);
  }

  update() {
    const now = Date.now();
    const difference = this.endTimestamp - now;

    if (difference <= 0) {
      // Countdown has ended
      this.daysElement.textContent = '00';
      this.hoursElement.textContent = '00';
      this.minutesElement.textContent = '00';
      this.secondsElement.textContent = '00';
      
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      return;
    }

    // Calculate time units
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    // Update DOM elements
    this.daysElement.textContent = String(days).padStart(2, '0');
    this.hoursElement.textContent = String(hours).padStart(2, '0');
    this.minutesElement.textContent = String(minutes).padStart(2, '0');
    this.secondsElement.textContent = String(seconds).padStart(2, '0');
  }

  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

// Store countdown instances
const countdownInstances = new WeakMap();

// Initialize countdown timers
function initCountdowns() {
  const countdownElements = document.querySelectorAll('.announcement-countdown:not([data-initialized])');
  
  countdownElements.forEach((element) => {
    // Mark as initialized
    element.dataset.initialized = 'true';
    
    // Create and store instance
    const countdown = new AnnouncementCountdown(element);
    countdownInstances.set(element, countdown);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdowns);
} else {
  initCountdowns();
}

// Clean up on page unload
window.addEventListener('beforeunload', () => {
  const countdownElements = document.querySelectorAll('.announcement-countdown[data-initialized]');
  countdownElements.forEach((element) => {
    const countdown = countdownInstances.get(element);
    if (countdown) {
      countdown.destroy();
    }
  });
});

// Re-initialize for theme editor (Shopify design mode)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCountdowns);
  document.addEventListener('shopify:section:reorder', initCountdowns);
}

